// EmailBodyOverride — optional email body that overrides the commentary.
// null = "use commentary as body" (checkbox unchecked).
// Checking the box enables the textarea; unchecking clears back to null.

import { useState, useEffect } from "react";

interface Props {
  /** null means "use commentary as email body" */
  emailBody: string | null;
  onChange: (body: string | null) => void;
  disabled?: boolean;
}

export function EmailBodyOverride({ emailBody, onChange, disabled = false }: Props) {
  const enabled = emailBody !== null;
  const [text, setText] = useState(emailBody ?? "");

  useEffect(() => {
    setText(emailBody ?? "");
  }, [emailBody]);

  return (
    <div>
      <label
        style={{
          display: "flex",
          alignItems: "center",
          gap: 8,
          fontSize: "var(--fs-sm)",
          color: "var(--color-bone-dim)",
          cursor: disabled ? "not-allowed" : "pointer",
          userSelect: "none",
        }}
      >
        <input
          type="checkbox"
          checked={enabled}
          disabled={disabled}
          onChange={(e) => {
            if (e.target.checked) {
              // Enable override; preserve any previously typed text
              onChange(text);
            } else {
              onChange(null);
            }
          }}
          style={{ accentColor: "var(--color-teal)", cursor: "inherit" }}
        />
        Override email body
      </label>

      {enabled && (
        <textarea
          value={text}
          disabled={disabled}
          rows={4}
          placeholder="Email body (sent to your inbox; forward this to the end advertiser)"
          onChange={(e) => {
            setText(e.target.value);
            onChange(e.target.value);
          }}
          style={{
            width: "100%",
            padding: 12,
            marginTop: 8,
            fontFamily: "var(--font-sans)",
            fontSize: "var(--fs-sm)",
            lineHeight: 1.6,
            background: "rgba(255,255,255,0.03)",
            color: disabled ? "var(--color-bone-dim)" : "var(--color-bone)",
            border: "1px solid rgba(255,255,255,0.08)",
            borderRadius: "var(--radius-sm)",
            resize: "vertical",
            outline: "none",
          }}
        />
      )}
    </div>
  );
}
